module.exports = __webpack_public_path__ + "static/img/5.1b7d316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/list/5.png
// module id = N6x7
// module chunks = 1